/**
 * Internal Error Media Key Status.
 *
 *
 * @beta
 */
export const INTERNAL_ERROR = 'internal-error'
